import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LazyViewModule } from '../../lazy-view/lazy-view.module';
import { PersonPictureModule } from '../../person-picture/person-picture.module';
import { ActivityDescriptionModule } from '../activity/activity-description.module';
import { AnalyticsDescriptionModule } from '../analytics/analytics-description.module';
import { PreloadModule } from '../directives/preload/preload.module';
import { SharedComponentsModule } from '../directives/shared-components.module';
import { UrlCachePipeModule } from '../directives/url-cache-pipe/url-cache-pipe.module';
import { FocusOnLoadModule } from '../focus-on-load/focus-on-load.module';
import { IconFontModule } from '../icon-font/icon-font.module';
import { KeyboardFocusTooltipModule } from '../keyboard-focus-tooltip/keyboard-focus-tooltip.module';
import { MeetingAttendeeToPersonPipe } from './meeting-attendee-to-person.pipe';
import { MruItemComponent } from './mru-item.component';

@NgModule({
    imports: [
        CommonModule,
        IconFontModule,
        SharedComponentsModule,
        ActivityDescriptionModule,
        AnalyticsDescriptionModule,
        FocusOnLoadModule,
        PreloadModule,
        LazyViewModule,
        UrlCachePipeModule,
        PersonPictureModule,
        KeyboardFocusTooltipModule
    ],
    declarations: [
        MruItemComponent,
        MeetingAttendeeToPersonPipe
    ],
    exports: [
        MruItemComponent
    ]
})

export class MruItemModule {
}
